'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = require('./components/login');

Object.defineProperty(exports, 'Login', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_login).default;
  }
});

var _loginOverlay = require('./components/login-overlay');

Object.defineProperty(exports, 'LoginOverlay', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loginOverlay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/index.js
// module id = 539
// module chunks = 1